import * as LJS from "../../lib/littlejs.esm";
import Globals from '../globals.ts';
import Object from "./object.ts";
class FallingPlatform extends Object {
    constructor(pos, world) {
        super(pos, 83, world, 45);
        this.walkable = true;
        this.fallDelay = 120;
        this.fallTimer = 0;
        this.isGoingToFall = false;
        this.isFalling = false;
        this.xOffset = 0;
        this.mass = 0; // Not affected by gravity
    }
    collideWithObject(object) {
        // If we collide with the player
        if (object === Globals.player) {
            // We disable the collision when he is going up to jump through
            if (object.velocity.y > 0) {
                return false;
            }
        }
        // Normal collision otherwise
        return super.collideWithObject(object);
    }
    update() {
        super.update();
        if (this.isGoingToFall) {
            this.fallTimer++;
            // During the last 0.5 second on the timer, the platform shakes
            if (this.fallDelay - this.fallTimer < 30) {
                this.xOffset = Math.floor(this.fallTimer / 5) % 2 == 0 ? 0.1 : -0.1;
            }
        }
        // If we reach the end of the timer, it falls
        if (this.fallTimer >= this.fallDelay) {
            // Make the platform fall
            this.gravityScale = 1;
            this.mass = 1;
            this.defaultMass = 1;
            // Disable timer
            this.isGoingToFall = false;
            this.fallTimer = 0;
            this.isFalling = true;
        }
        // If the platform is disabled we do not check collisions
        if (this.disabled) {
            return;
        }
        // Check if player is on this platform
        if (!this.isGoingToFall && !this.fallTimer && !this.isFalling) {
            let vertDist = Globals.player.pos.y - this.pos.y;
            let horDist = Globals.player.pos.x - this.pos.x;
            if (vertDist <= 1.02 && vertDist >= 0.98 && horDist > -1 && horDist < 1 && Globals.player.velocity.y <= 0) {
                this.isGoingToFall = true;
            }
        }
    }
    // Draws the tile, taking into account the xOffset when it shakes
    render() {
        LJS.drawTile(LJS.vec2(this.pos.x + this.xOffset, this.pos.y), LJS.vec2(1), this.tileInfo);
    }
    /**
     * Called by Object.update() each frame if the object is active
     */
    defaultCollision() {
        if (this.isFalling) {
            this.setCollision(false, false, false, false);
        }
        else {
            this.setCollision(true, true, false, false);
        }
    }
}
export default FallingPlatform;
